import { Box, Button, Card, CardContent, Grid, Pagination, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { connect } from "react-redux";
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import Loader from '../../../utility/Loader';
import api_service from "../../../network/api_callbacks";

const RapHousieGame = (props) => {

    const navigate = useNavigate();
    const location = useLocation();
    const isCreatePage = location.pathname.includes("create-raphousie-game");
    const pathname = location.pathname;
    const state = location.state;
    console.log("location : ", location);
    console.log("location.pathname : ", pathname);
    console.log("location.state : ", state);

    const DEFAULT_PAGINATION_ITEM_COUNT = 30;
    const DEFAULT_PAGINATION_PAGE = 1;
    const [page, setPage] = useState(DEFAULT_PAGINATION_PAGE);
    const [loader, setLoader] = useState(false);
    const [tambolaGamesList, setTambolaGamesList] = useState([]);
    const [tambolaGamesPaginationData, setTambolaGamesPaginationData] = useState(null);

    useEffect(() => {
        if (state?.shouldRefresh) {
            getTambolaGamesList();
        }
    }, [state?.shouldRefresh]);

    useEffect(() => {
        if (!tambolaGamesPaginationData && tambolaGamesList?.length === 0) {
            getTambolaGamesList();
        }
    }, []);


    const getTambolaGamesList = async (pageToFetch = page) => {
        setLoader(true);
        try {
            const response = await api_service.getTambolaGamesList({ _page: pageToFetch, _limit: DEFAULT_PAGINATION_ITEM_COUNT });

            const listData = response?.data;
            const paginationData = response?.pagination;

            console.log('📘 response :', response);
            console.log('📘 listData :', listData);
            console.log('📘 paginationData :', paginationData);

            // const duplicatedList = Array.from({ length: 10 }, (_, i) =>
            //     listData?.map((item, idx) => ({
            //         ...item,
            //         _id: `${item._id || "item"}_${i + 1}_${idx + 1}`,
            //         duplicateIndex: i + 1,
            //     }))
            // ).flat();

            console.log("length : ", listData?.length)
            setTambolaGamesList(listData || []);
            setTambolaGamesPaginationData(paginationData);
            setPage(pageToFetch);

            setLoader(false);
        } catch (error) {
            console.error('❌ Failed to fetch getTambolaMultimediaList:', error);
        }
    }

    const navigateToCreateTambolaGame = () => {
        navigate("create-raphousie-game", {
            state: { },
        })
    }

    const navigateToDetailOrEditTambolaGame = (item) => {
        navigate("create-raphousie-game", {
            state: { gameDataFromList: item },
        })
    }

    const GameItem = ({ item, onClick }) => {
        return (
            <Card
                sx={{
                    width: "100%",
                    maxWidth: 350,
                    mb: 3,
                    borderRadius: 3,
                    overflow: "hidden",
                    boxShadow: 4,
                    cursor: "pointer",
                    "&:hover": { boxShadow: 8 },
                }}
                onClick={onClick}
            >
                {/* Banner on Top */}
                <Box
                    sx={{
                        width: "100%",
                        height: 180,
                        backgroundImage: `url(${item?.banner?.fullWidth})`,
                        backgroundSize: "cover",
                        backgroundPosition: "center",
                    }}
                />

                {/* Details Section */}
                <CardContent
                    sx={{
                        backgroundColor: "#fff",
                        color: "#000",
                    }}>

                    <Box sx={{ display: "flex", justifyContent: "space-between", mb: 0 }}>
                        {/* Game ID */}
                        <Typography variant="subtitle1" sx={{ fontWeight: "bold", mb: 0 }}>
                            Game ID: {item?._id}
                        </Typography>
                    </Box>

                    <Box sx={{ display: "flex", justifyContent: "space-between", mb: 0 }}>
                        {/* Game ID */}
                        <Typography variant="subtitle1" sx={{ fontWeight: "bold", mb: 0 }}>
                            Title: {item?.title}
                        </Typography>
                    </Box>

                    {/* Times */}
                    <Box sx={{ display: "flex", justifyContent: "space-between", mb: 0 }}>
                        <Typography variant="body2" color="text.secondary">
                            Trigger Time: <strong>{item?.triggerTime}</strong>
                        </Typography>

                        <Typography variant="body2" color="text.secondary">
                            Daily GoLive: <strong>{item?.dailyGoLiveTime}</strong>
                        </Typography>
                    </Box>

                    <Box sx={{ display: "flex", justifyContent: "space-between", mb: 1 }}>
                        {/* Ticket Price */}
                        <Typography variant="body2" color="text.secondary">
                            Ticket Price: <strong>{item?.ticketPrice?.rapCoin} RapCoin</strong>
                        </Typography>

                        {/* Status */}
                        <Typography variant="body2" color="text.secondary">
                            Status: <strong>{item?.status}</strong>
                        </Typography>
                    </Box>

                </CardContent>
            </Card>
        );
    };

    const ShowGamesList = () => {
        return (
            <Grid container spacing={2} justifyContent="center" alignItems="center" marginBottom={4}>
                {tambolaGamesList?.map((item) => {
                    return (
                        <GameItem
                            key={item?._id}
                            item={item}
                            onClick={() => navigateToDetailOrEditTambolaGame(item)}
                        />
                    )
                })}
            </Grid>
        )
    }

    return (
        <>
            {!isCreatePage ?
                <Box sx={{
                    flex: 1,
                    height: '100%',
                    display: "flex",
                    padding: 0,
                    flexDirection: "column",
                    gap: 0,
                    marginBottom: 4,
                    position: "relative",
                    overflow: "auto"
                }}>

                    <Box sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        mb: 2,
                        padding: 4,
                        position: "sticky",   // ✅ stick within parent container
                        top: 0,               // ✅ stick to the top
                        zIndex: 5,            // ✅ ensure it stays above content
                        backgroundColor: "#fff",
                        borderBottom: "1px solid #ddd", // optional for visual separation
                    }}>

                        <Typography variant="h5" sx={{ mt: 0, fontWeight: 700, textAlign: 'end' }}>Rap Housie Games</Typography>

                        {/* <Button
                            variant="contained"
                            color="success"
                            sx={{ borderRadius: 2, textTransform: "none", mr: 0, height: 40, width: 'auto' }}
                            onClick={() => {
                                //onCreateClick();
                                navigateToCreateTambolaGame();
                            }}
                        >
                            Create Game
                        </Button> */}
                    </Box>

                    <ShowGamesList />

                    {/* Pagination */}
                    <Box sx={{ display: "flex", justifyContent: "center", mt: 0 }}>
                        {tambolaGamesPaginationData && (
                            <Pagination
                                count={tambolaGamesPaginationData?.totalPages || 1}
                                page={page}
                                onChange={(_, newPage) => getTambolaGamesList(newPage)}
                                color="primary"
                                size="large"
                                variant="outlined"
                                shape="rounded"
                                sx={{
                                    mt: 2,
                                    "& .MuiPaginationItem-root": {
                                        borderRadius: "8px",
                                        fontWeight: "bold",
                                        color: "#444",
                                    },
                                    "& .Mui-selected": {
                                        backgroundColor: "#1976d2 !important",
                                        color: "#fff",
                                        boxShadow: "0 2px 6px rgba(0,0,0,0.2)",
                                    },
                                    "& .MuiPaginationItem-root:hover": {
                                        backgroundColor: "rgba(25, 118, 210, 0.1)",
                                    },
                                }}
                            />
                        )}
                    </Box>

                    {/* ✅ Loader overlay in center */}
                    {loader && (
                        <Box
                            sx={{
                                position: "fixed", // ✅ fixed to viewport
                                top: 0,
                                left: 0,
                                right: 0,
                                bottom: 0,
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                background: "rgba(255,255,255,0.6)",
                                zIndex: 1300, // higher than sticky header

                                // position: "absolute",
                                // top: "50%",
                                // left: "50%",
                                // transform: "translate(-50%, -50%)", // ✅ Center correctly
                                // display: "flex",
                                // justifyContent: "center",
                                // alignItems: "center",
                                // background: "rgba(255,255,255,0.6)",
                                // zIndex: 10,
                                // width: "100%",
                                // height: "100%",
                            }}
                        >
                            <Loader />
                        </Box>)}
                </Box>
                :
                <Outlet />}
        </>
    );
}

const mapStateToProps = (state) => {
    return {

    }
};

const mapDispatchToProps = {

};

export default connect(mapStateToProps, mapDispatchToProps)(RapHousieGame)